import api from './client'

/** STOCK → Fotos pendientes: candidatas encontradas por el agente, a aprobar o rechazar. */
export const fotosCandidatasApi = {
  listar: (dias = 30) => api.get('/fotos-candidatas', { params: { dias } }),
  aprobar: (id) => api.post(`/fotos-candidatas/${id}/aprobar`),
  rechazar: (id, motivo) => api.post(`/fotos-candidatas/${id}/rechazar`, { motivo }),
  buscar: (sku) => api.post('/fotos-candidatas/buscar', { sku }),
}
